export interface TextAutocompleteItem {
    /**
     * Value that will be inserted between triggerStart and triggerEnd.
     */
    value: string;
    /**
     * Optional text to display in the dropdown. Falls back to value when not provided.
     */
    description?: string;
    /**
     * When true, this item cannot be selected (click or Enter). Keyboard navigation skips it.
     */
    disabled?: boolean;
}

export interface TextAutocompleteGroup {
    /**
     * Group label displayed above the grouped items.
     */
    label: string;
    /**
     * Whether the entire group is disabled.
     */
    disabled?: boolean;
    /**
     * Items that belong to this group.
     */
    items: TextAutocompleteItem[];
}

/**
 * Optional autocomplete configuration that enables a dropdown of items
 * when the user types the configured triggerStart sequence.
 */
export interface TextAutocompleteConfig {
    /**
     * String that starts the autocomplete sequence, e.g. '{{'.
     * Defaults to '{{' when not provided.
     */
    triggerStart?: string;
    /**
     * String that ends the autocomplete sequence, e.g. '}}'.
     * Defaults to '}}' when not provided.
     */
    triggerEnd?: string;
    /**
     * Flat list of items available for insertion.
     * You can use this alone or together with groups.
     */
    items?: TextAutocompleteItem[];
    /**
     * Optional grouped items, similar to mat-optgroup.
     * When provided, items are displayed under their group labels.
     */
    groupedItems?: TextAutocompleteGroup[];
    /**
     * Custom CSS class for the autocomplete dropdown.
     */
    class?: string;
    /**
     * Whether the first option should be highlighted automatically when the autocomplete panel is opened.
     * Defaults to false when not provided.
     */
    autoActiveFirstOption?: boolean;
    /**
     * When true, the syntax of autocomplete triggers is not validated and no validation errors are shown.
     * Can be used to handle own validation logic.
     */
    ignoreValidation?: boolean;
    /**
     * Critical width of the autocomplete panel. If the width is smaller than this value, the description of items is hidden.
     */
    dropdownCriticalWidth?: number;
}
